import $ from 'jquery';
import 'jquery-ui/ui/widgets/sortable';
import {selectOptionfromValue, ajaxCall} from './functions';
import Swal from 'sweetalert2';
import DataTable from 'datatables.net-jqui';

jQuery(function($){

    //seelct options from value
    $('select').each(function(){
        selectOptionfromValue( $(this) );
    });

    $('.hide').hide();

    if( $('button.view-invoice').length > 0 )
    {
        console.log('invoice button found');
        $('button.view-invoice').on('click', function(e){
            e.preventDefault();
            let orderId = $(this).data('orderId');
            console.log($(this));
            if( orderId == '' )
            {
                Swal.fire('Error', 'Booking id not found!', 'error');
                return false;
            }
            let btn = $(this);
            let btnText = btn.html();
            btn.html('');
            btn.prepend('Loading..');

            //get file content
            let data = {
                action: 'get_invoice_pdf',
                orderId: orderId
            };
            ajaxCall( data ).then( function(response)
            {
                $('.view-invoice').find('.spinner-border').remove();
                
                if( response.success == false )
                {
                    Swal.fire('Error', response.data, 'error');
                    btn.html( btnText );
                    return;
                }

                //create iframe to invoice-pdf modal-body
                let iframe = $('<iframe/>', {
                    src: response.data,
                    style: 'width: 100%; height: 100%;'
                });

                //open modal
                Swal.fire({
                    title: '#'+orderId+' Invoice',
                    html: iframe,
                    showCloseButton: true,
                    showConfirmButton: false,
                    width: '90%',
                    heightAuto: false
                });

                $('#swal2-html-container').css('height', $(window).height() - 100);

                btn.html( btnText );
                
            });
        });
    }

    if( document.querySelector('.ncDataTable') !== null )
    {
        window.dTable = new DataTable('.ncDataTable', {
            responsive: true   
        });
    }

    if( $('.nc-sortable').length > 0 )
        $('.nc-sortable').sortable();
        
});